var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notifications && _vm.notifications.length > 0)?_c('div',_vm._l((_vm.notifications),function(notification){return _c('notification-alert',{key:notification.id,attrs:{"item":notification},on:{"dismiss":_vm.onNotificationDismiss}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }